import { Box, Grid, Snackbar, SnackbarContent, Stack } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'

import Header from './components/Header'
import Nav from './components/Nav'
import Panel from './components/Panel'
import Preview from './components/Preview'
import { useToolBuilder } from './Hook'
import { Idea } from './templates/Idea'
import { useAppDispatch, useAppSelector } from 'redux/Hook'
import { fetchTool } from 'redux/thunks/ToolBuilder'
import ToolHeader from './components/Header/ToolHeader'
import ActionButtons from './components/Header/ActionButtons'
import { setValidationError } from 'redux/slices/ToolBuilder'
import { fetchPinnedItems } from 'redux/thunks/PinnedItems'
import { fetchProject } from 'redux/thunks/Project'
import NotFound from 'components/Shared/ErrorPages/404'
import {
  PlatformAdmin,
  SiteAdmin,
  HubAdmin,
  ProjectAdmin,
} from 'lib/authorization/Roles'

function ToolBuilder() {
  const dispatch = useAppDispatch()
  const { toolId, toolType, projectId } = useToolBuilder()
  const [openSnackbar, setOpenSnackbar] = useState(false)

  const { error } = useAppSelector((state) => state.toolBuilder)
  const validationRef = useRef<any>()

  const { project, fetching: fetchingProject } = useAppSelector(
    (state) => state.project,
  )
  const roleInCurrentContext = project?.roleInCurrentContext

  useEffect(() => {
    if (error) {
      setOpenSnackbar(true)
    }
  }, [error])

  const handleClose = () => {
    setOpenSnackbar(false)
    dispatch(setValidationError({ error: null }))
  }

  const {
    toolTabs,
    toolTabValue,
    setToolTabValue,
    livePreviewWidth,
    setLivePreviewWidth,
  } = useToolBuilder()

  useEffect(() => {
    if (toolId && toolType) dispatch(fetchTool())
    if (projectId) {
      dispatch(fetchPinnedItems())
      dispatch(fetchProject({ projectId }))
    }
  }, [])

  if (!projectId || !toolType) return <NotFound />

  if (fetchingProject) return null

  if (
    [PlatformAdmin, SiteAdmin, HubAdmin, ProjectAdmin].includes(
      roleInCurrentContext,
    )
  ) {
    return (
      <Box>
        <Header
          leftNode={<ToolHeader />}
          rightNode={<ActionButtons formRef={validationRef} />}
        />
        <Nav
          toolTabValue={toolTabValue}
          setToolTabValue={setToolTabValue}
          livePreviewWidth={livePreviewWidth}
          setLivePreviewWidth={setLivePreviewWidth}
        />
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={openSnackbar}
          autoHideDuration={5000}
          onClose={handleClose}
        >
          <SnackbarContent
            sx={{
              '&.MuiSnackbarContent-root': {
                backgroundColor: '#d32f2f',
                color: '#fff',
              },
            }}
            message={
              <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <ErrorOutlineOutlinedIcon />
                {error}
              </span>
            }
          />
        </Snackbar>

        <Grid container bgcolor="grey.300">
          <Panel toolTabValue={toolTabValue}>
            <Stack spacing={3}>
              <Idea tab={toolTabs[toolTabValue]} ref={validationRef} />
            </Stack>
          </Panel>
          <Preview livePreviewWidth={livePreviewWidth} />
        </Grid>
      </Box>
    )
  }
  return <NotFound />
}

export default ToolBuilder
